import { memo } from 'react';
import { formatValue } from '../../utils/dataTransformers';

interface SnowRateCellProps {
  value: number | null;
  groupInterval?: '3' | '6' | '12' | '24' | 'none';
}

const getMaxRange = (groupInterval?: '3' | '6' | '12' | '24' | 'none') => {
  switch (groupInterval) {
    case '3': return 3;
    case '6': return 6;
    case '12': return 10;
    case '24': return 16;
    default: return 1;
  }
};

const SnowRateCell = memo(({ value, groupInterval }: SnowRateCellProps) => {
  if (value === null) {
    return <div style={{ width: '100%', textAlign: 'center' }}>-</div>;
  }

  const maxRange = getMaxRange(groupInterval);
  const height = Math.min(Math.max((value / maxRange) * 100, 0), 100);
  
  return (
    <div style={{ 
      width: '100%', 
      height: '44px', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '2px'
    }}>
      <div style={{
        width: '60%',
        height: `${height}%`,
        backgroundColor: '#2196f3',
        borderRadius: '2px 2px 0 0',
        transition: 'height 0.2s ease-in-out'
      }} />
      <div style={{ fontSize: '11px', marginTop: '2px' }}>
        {formatValue(value, false, true, true)}
      </div>
    </div>
  );
});

export default SnowRateCell;
